module.exports = __webpack_public_path__ + "img/EXTERIOR-VITARA-CRISTAL.3d226ce0.jpg";